// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__37ABw","title":"Section_title__2S6oE","row":"Section_row__3daCM"};